import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCheck } from 'react-icons/fi';

const Trust = () => {
  const points = [
    "Manually reviewed using public data practices",
    "Focused on real-world risk, not legal jargon",
    "Clear, actionable recommendations"
  ];

  return (
    <div className="bg-zinc-50 pb-20 px-6">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12">
        {points.map((point, idx) => (
          <div key={idx} className="flex items-center gap-2 text-zinc-600 font-medium text-sm md:text-base">
            <SafeIcon icon={FiCheck} className="text-zinc-900 w-5 h-5" />
            <span>{point}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Trust;